module.exports = "/_next/static/images/c688068db8d570ce35b6d203ae7d183c-nu-card-lg@2x.jpg";